import React, { useState } from "react";
import { toast } from "react-toastify";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { Router, useNavigate } from "react-router-dom";
import PrintIcon from "@mui/icons-material/Print";

// import JS files
import MuiButton from "../../../shares/MuiButton";
import useFetch from "../../../../context/useFetch";
import { fixNumbers } from "../../../../utils";
import PanelFilter from "../../../shares/PanelFilter";
import PanelTemplate from "../../../shares/PanelTemplate";
import { useUserData } from "../../../../context/UserDataContext";
import PanelTable from "../../../shares/PanelTable";

const AdminReportsAcceptOrder = () => {
  const navigate = useNavigate();
  const [codeFilter, setCodeFilter] = useState(null);

  const headersList = [
    { colName: "code", name: "کد" },
    { colName: "show_name", name: "النگو" },
    { colName: "brand", name: "برند" },
    { colName: "gender", name: "سن" },
    { colName: "color", name: "رنگ" },
    { colName: "first_name", name: "نام تولیدکننده" },
    { colName: "last_name", name: "نام خانوادگی تولیدکننده" },
    { colName: "admin_size_one_num", name: " یک" },
    { colName: "admin_size_two_num", name: " دو" },
    { colName: "admin_size_three_num", name: " سه" },
    { colName: "admin_size_four_num", name: " چهار" },
    { colName: "admin_size_five_num", name: " پنج" },
    { colName: "admin_size_six_num", name: " شش" },

    { colName: "admin_own_accept_size_one_num", name: " ت.یک" },
    { colName: "admin_own_accept_size_two_num", name: " ت.دو" },
    { colName: "admin_own_accept_size_three_num", name: " ت.سه" },
    { colName: "admin_own_accept_size_four_num", name: " ت.چهار" },
    { colName: "admin_own_accept_size_five_num", name: " ت.پنج" },
    { colName: "admin_own_accept_size_six_num", name: " ت.شش" },
  ];

  const mobileHeadersList = [
    { colName: "code", name: "کد" },
    { colName: "show_name", name: "النگو" },
    { colName: "brand", name: "برند" },
  ];

  const dataKey = [
    "object.bangle.code",
    "object.bangle.show_name",
    "object.bangle.brand",
    "gender",
    "color",
    "first_name",
    "last_name",
    "admin_size_one_num",
    "admin_size_two_num",
    "admin_size_three_num",
    "admin_size_four_num",
    "admin_size_five_num",
    "admin_size_six_num",
    "admin_own_accept_size_one_num",
    "admin_own_accept_size_two_num",
    "admin_own_accept_size_three_num",
    "admin_own_accept_size_four_num",
    "admin_own_accept_size_five_num",
    "admin_own_accept_size_six_num",
  ];

  const filterList = [
    {
      type: "textField",
      label_fa: "کد",
      label_en: "code",
      state: codeFilter,
      isLTR: true,
    },
  ];

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
  };

  const filter = () => {
    getRequestListApi.reFetch();
  };

  const reset_filter = () => {
    setCodeFilter(null);
    getRequestListApi.reFetch();
  };
  const { userData } = useUserData();
  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
  });

  const [requestList, setRequestList] = useState([]);

  const getRequestListApi = useFetch({
    method: "get",
    params: {
      code: fixNumbers(codeFilter),
    },
    url: `User_Service/${userData.username}/admin_get_report_customer_order_items`,
    trigger: true,
    pagination: paginationPageInfo,
    setter: setRequestList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const buttonsList = [];

  const actionsList = [];

  const handelPrintReport = () => {
    navigate("/print-report-accept-order-admin");
  };

  return (
    <>
      <PanelTemplate sidebarActiveLink="r-accept-order-admin">
        <div className="panel-main-header">
          <span>درخواست ها، تایید شده النگوها توسط ادمین</span>
        </div>
        <PanelFilter
          header="فیلتر :"
          list={filterList}
          update_filter={update_filter}
          filter={filter}
          reset_filter={reset_filter}
        />
        <div className="flex justify-end">
          <MuiButton
            onClick={handelPrintReport}
            variant="outlined"
            icon={<PrintIcon />}
            color="primary"
            text="چاپ گزارش"
            margin="mr-2"
          />
        </div>
        <PanelTable
          header="لیست النگوها:"
          headers={headersList}
          mobileHeaders={mobileHeadersList}
          data={requestList}
          dataKey={dataKey}
          buttons={buttonsList}
          actions={actionsList}
          icon={<AddShoppingCartIcon />}
          // setSelectedRow={setSelectedRow}
        />
      </PanelTemplate>
    </>
  );
};

export default AdminReportsAcceptOrder;
